import gqlTagSwag from 'graphql-tag';

export const epicFragment = gqlTagSwag`
    fragment EpicPanelIssueParentFragment on IssueParent {
        id
        key
        summary
        color
        childrenInfo {
            todoStats {
                issueCount
            }
            inProgressStats {
                issueCount
            }
            doneStats {
                issueCount
            }
        }
        startDate
        dueDate
    }
`;

export const estimationInfoFragment = gqlTagSwag`
    fragment EstimationInfoFragment on EstimationInfo {
        details {
            estimationType
            name
        }
        childrenEstimationStats {
            doneEstimate
            totalEstimate
            percentageCompleted
            notEstimated
        }
    }
`;

export const createEpicFragment = gqlTagSwag`
    fragment CreateIssueParentFragment on IssueParent {
        id
        key
        summary
        color
        issueType {
            id
            name
            iconUrl
        }
        childrenInfo {
            todoStats {
                issueCount
            }
            inProgressStats {
                issueCount
            }
            doneStats {
                issueCount
            }
        }
        startDate
        dueDate
    }
`;

/* ----- DEPRECATED, will be removed once pagination is fully rolled out ---- */
export const currentUserFragment = gqlTagSwag`
    fragment CurrentUserFragment on CurrentUser {
        permissions
    }
`;

export const boardLocationFragment = gqlTagSwag`
    fragment BoardLocationFragment on Project {
        id
        name
        key
    }
`;

export const timeTrackingOptionsFragment = gqlTagSwag`
    fragment TimeTrackingOptionsFragment on TimeTrackingOptions {
        workingHoursPerDay
        workingDaysPerWeek
        defaultUnit
        timeFormat
    }
`;

export const epicLiteFragment = gqlTagSwag`
    fragment EpicPanelIssueParentLiteFragment on IssueParent {
        id
        key
        summary
        color
        issueTypeDetails {
            id
            name
            iconUrl
        }
    }
`;

export const projectLocationFragment = gqlTagSwag`
    fragment ProjectLocationFragment on Project {
        id
        issueTypes {
            id
            name
            hierarchyLevelType
            iconUrl
            hasRequiredFields
        }
    }
`;

export const issueParentTypeConfigFragment = gqlTagSwag`
    fragment IssueParentTypeConfigFragment on IssueParentTypeConfig {
        id
        name
        iconUrl
        hierarchyLevelType
    }
`;

export const columnFragment = gqlTagSwag`
    fragment ColumnFragment on Column {
        isDone
        isInitial
    }
`;

export const boardFragment = gqlTagSwag`
    fragment BoardFragment on Board {
        rankCustomFieldId
    }
`;
